import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { DefaultButton } from "@fluentui/react/lib/Button";
import subscriptionService, { ISubscription, SubscriptionType } from "../../services/SubscriptionService";
import Auth from "../../Auth/Auth";
import { useHistory } from "react-router-dom";
import { Separator, Spinner, SpinnerSize } from "@fluentui/react";
import SuscripcionSelector from "../Payments/SuscripcionSelector/SuscripcionSelector";
import { DEFAULT_PLAN } from "../Payments/SuscripcionSelector/util";
import DocumentTitle from "react-document-title";

export const MainTitle = styled.h2`
	text-align: center;
	display: block !important;
	margin-top: 0;
	margin-bottom: 0;
	padding-top: 1em;
	font-size: 25px !important;
	color: ${props => props.theme.palette.black};
`;

export const Description = styled.p`
	margin: 0;
	overflow-y: hidden;
	max-height: 10em;
	padding-top: 1em;
	padding-left: 1em;
	padding-right: 1em;
	font-size: 23px;
	text-align: justify;
`;

export const SelectedDiv = styled.div`
	background-color: ${props => props.theme.palette.greyMorePlansSelected};
	padding-right: 0;
	border-radius: 12px;
	text-overflow: ellipsis;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 1em;
    margin: 5px;
`;

export const Button = styled(DefaultButton)``;

export const MoreExperiencePlans = () => {
	const user = Auth.getUserProfile();
	const prevSubscription = Auth.getExperienceSubscription();
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [subscriptions, setSubscriptions] = useState<SubscriptionType[]>([]);

	const portfolioAmount = localStorage.getItem('portfolioValue');

	useEffect(() => {
		if (user.id) {
			subscriptionService.getSubscriptionsByType("experience").then((subscriptions) => {
				var index: number = subscriptions.findIndex((element: SubscriptionType) => element.id?.toString() === prevSubscription);
				if (index !== -1) {
					subscriptions[index].isSelected = true;
				}

				const filterSubscriptions = subscriptions.filter((subs: ISubscription) => subs.period === "year").sort((a, b) => {
					if (a.limit === null || !a.limit) return 1;
					if (b.limit === null || !b.limit) return -1;
					return a.limit - b.limit;
				});
				setSubscriptions(filterSubscriptions);
				setIsLoading(false);
			});
		}
	}, [prevSubscription, user.id]);

	const [selectedPlan, setSelectedPlan] = useState<ISubscription>(DEFAULT_PLAN);

	const history = useHistory();

	const handleContinuar = () => {
		if (!selectedPlan) return;

		Auth.setExperienceSubscription(selectedPlan.id);

		history.push({
			pathname: "/savingsPlans/iHaveExperience",
		});
	};

	if (isLoading === true) {
		return <Spinner size={SpinnerSize.large} />;
	} else {
		return (
			<DocumentTitle title = 'IronIA - Seleccionar Suscripción'>
				<>
					<h2>Seleccionar Suscripción</h2>
					<Separator />
					<React.Fragment>
						<div className="shadow">
							<SuscripcionSelector
								subscriptions={subscriptions ?? []}
								selectedPlan={selectedPlan}
								currentAmount={portfolioAmount ? JSON.parse(portfolioAmount).portfolioValue : 0}
								setSelectedPlan={setSelectedPlan}
								/>
							<div className="suscriptionButton__container">
								<DefaultButton className="button tiny-primary-button"
								text="Continuar"
								onClick={handleContinuar} />
							</div>
						</div>
					</React.Fragment>
				</>
			</DocumentTitle>
		);
	}
};
